//import { BrowserRouter as ReactRouter } from 'react-router-dom';
import { Router } from 'react-router'
import { history } from './../store/history.js';
import React from 'react';
import Routes from './routes.js';

const AppRouter = () => (
	<Router history={history}>
		<Routes />
	</Router>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./mobile-core/src/router/router.js